import { ComboBoxPlain } from "~/components/formElements/ComboBox.tsx";
import { useAuth } from "~/contexts/AuthContext";
import useUserSelectOptions from "~/hooks/form/formOptionsData/useUsersSelectOptions.ts";
import { useDashboardUser, useDebugUserSelection } from "~/modules/dashboard/hooks/useDashboardUser.tsx";

// Debug tool, not part of the page: `DashboardView` shows it in a marked box at the end of the page, in
// non-production builds only. It shows the dashboard of another user. The backend refuses the reads that the signed-in
// user may not make, and the box then shows its error text.
export function DashboardUserPicker() {
	const { user: signedInUser } = useAuth();
	const dashboardUser = useDashboardUser();
	const userSelectOptions = useUserSelectOptions();
	const { setDebugUserId } = useDebugUserSelection();

	const handleChange = (userId: string | number | { value: string | number } | null) => {
		const id = typeof userId === "object" && userId ? userId.value : userId;
		setDebugUserId(id && id !== signedInUser?.id ? String(id) : null);
	};

	return (
		<div className="w-56">
			<ComboBoxPlain allowNew={false}
						   value={dashboardUser?.id}
						   optionsData={userSelectOptions}
						   onChange={handleChange} />
		</div>
	);
}
